import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {SidePanel} from 'front-onceforall-core';
import OrganisationItem from '../../../../organisation/OrganisationItem';

function SelectClientPanelView(props) {
  if (!props.isOpen) {
    return null;
  }

  let triggerClosePanel = () => {};
  const {organisation} = props;

  return (
    <SidePanel
      onClose={props.onClose}
      setCloseTrigger={closeFunction => {
        triggerClosePanel = closeFunction;
      }}
    >
      <h2><Translate value="action.openSwitchOrganisation"/></h2>
      <p>
        <Translate
          value="globalSubcontractor.selectClientForSubcontractor"
          subcontractorName={organisation.fullName}
        />
      </p>
      <div style={{position: 'relative'}}>
        {props.loading ?
          <div className="loading-overlay"/> :
          props.clients.map((client, index) => <div
            data-id={`client-${index}`}
            key={`client-${index}`}
            onClick={() => props.onSelectClient(client)}
          >
            <OrganisationItem organisation={client}/>
          </div>)
        }
      </div>
      <div className="mt-5">
        <button
          type="button"
          className="large secondary"
          onClick={() => triggerClosePanel()}
          data-id="cancel"
        >
          <Translate value="action.cancel"/>
        </button>
      </div>
    </SidePanel>
  );
}

SelectClientPanelView.propTypes = {
  organisation: PropTypes.object.isRequired,
  clients: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSelectClient: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default SelectClientPanelView;
